import { render, staticRenderFns } from "./LeftMenuListGroup.vue?vue&type=template&id=16c8c36b&scoped=true&"
import script from "./LeftMenuListGroup.vue?vue&type=script&lang=js&"
export * from "./LeftMenuListGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c8c36b",
  null
  
)

export default component.exports